interface ISiteFilter {
    getName(): string;
    setContent(values: ISiteFilterItem): void;
    hasValue(): boolean;
}

interface ISiteElementFilterRenderer {
    getState(): any;
}
interface ISiteElementFilterRendererQueryElement
    extends IQueryElement, ISiteElementFilterRenderer {
    
}

abstract class SiteElementFilter
    extends QueryElement<HTMLElement>
    implements ISiteFilter {

    private readonly _site: SiteAssortment;

    constructor(element: HTMLElement, site: SiteAssortment) {
        super(element);

        this._site = site;
    }
    getName(): string {
        return this.getAttr("data-filter") || "";
    }
    getConfig<T>(defaultConfig: T): T {
        let elementConfig = JSON.parse(this.getAttr("data-config") || "{}");
        return {...defaultConfig, ...elementConfig};
    }

    protected getSite() {
        return this._site;
    }

    abstract hasValue(): boolean;
    abstract setContent(values: ISiteFilterItem): void;
}